export const CHART_COLORS = [
    "#6C8EBF",
    "#82CA9D",
    "#8884D8",
    "#FF7C7C",
    "#FFBB28",
    "#FF8042",
    "#B39DDB",
    "#80DEEA",
];

export const getColor = (index) => CHART_COLORS[index % CHART_COLORS.length];
